var Ut = Object.defineProperty;
var Xt = (r, e, t) => e in r ? Ut(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => (Xt(r, typeof e != "symbol" ? e + "" : e, t), t);
import * as qt from "react";
import it, { forwardRef as ye, createRef as Y, useCallback as Pe, createContext as Ht, useContext as Jt, useRef as ae, useState as ve, useEffect as ot } from "react";
var pe = { exports: {} }, X = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qe;
function Kt() {
  if (qe)
    return X;
  qe = 1;
  var r = it, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, o = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(d, f, g) {
    var h, p = {}, m = null, y = null;
    g !== void 0 && (m = "" + g), f.key !== void 0 && (m = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (h in f)
      i.call(f, h) && !a.hasOwnProperty(h) && (p[h] = f[h]);
    if (d && d.defaultProps)
      for (h in f = d.defaultProps, f)
        p[h] === void 0 && (p[h] = f[h]);
    return { $$typeof: e, type: d, key: m, ref: y, props: p, _owner: o.current };
  }
  return X.Fragment = t, X.jsx = c, X.jsxs = c, X;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var He;
function Zt() {
  return He || (He = 1, process.env.NODE_ENV !== "production" && function() {
    var r = it, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), d = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), A = Symbol.iterator, I = "@@iterator";
    function k(n) {
      if (n === null || typeof n != "object")
        return null;
      var l = A && n[A] || n[I];
      return typeof l == "function" ? l : null;
    }
    var D = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(n) {
      {
        for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), _ = 1; _ < l; _++)
          u[_ - 1] = arguments[_];
        V("error", n, u);
      }
    }
    function V(n, l, u) {
      {
        var _ = D.ReactDebugCurrentFrame, P = _.getStackAddendum();
        P !== "" && (l += "%s", u = u.concat([P]));
        var S = u.map(function(E) {
          return String(E);
        });
        S.unshift("Warning: " + l), Function.prototype.apply.call(console[n], console, S);
      }
    }
    var ee = !1, gt = !1, mt = !1, vt = !1, pt = !1, Ie;
    Ie = Symbol.for("react.module.reference");
    function bt(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === i || n === a || pt || n === o || n === g || n === h || vt || n === y || ee || gt || mt || typeof n == "object" && n !== null && (n.$$typeof === m || n.$$typeof === p || n.$$typeof === c || n.$$typeof === d || n.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === Ie || n.getModuleId !== void 0));
    }
    function Et(n, l, u) {
      var _ = n.displayName;
      if (_)
        return _;
      var P = l.displayName || l.name || "";
      return P !== "" ? u + "(" + P + ")" : u;
    }
    function Se(n) {
      return n.displayName || "Context";
    }
    function N(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case g:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case d:
            var l = n;
            return Se(l) + ".Consumer";
          case c:
            var u = n;
            return Se(u._context) + ".Provider";
          case f:
            return Et(n, n.render, "ForwardRef");
          case p:
            var _ = n.displayName || null;
            return _ !== null ? _ : N(n.type) || "Memo";
          case m: {
            var P = n, S = P._payload, E = P._init;
            try {
              return N(E(S));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, G = 0, we, Te, Re, Ce, Me, Ae, De;
    function je() {
    }
    je.__reactDisabledLog = !0;
    function yt() {
      {
        if (G === 0) {
          we = console.log, Te = console.info, Re = console.warn, Ce = console.error, Me = console.group, Ae = console.groupCollapsed, De = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        G++;
      }
    }
    function Pt() {
      {
        if (G--, G === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, n, {
              value: we
            }),
            info: B({}, n, {
              value: Te
            }),
            warn: B({}, n, {
              value: Re
            }),
            error: B({}, n, {
              value: Ce
            }),
            group: B({}, n, {
              value: Me
            }),
            groupCollapsed: B({}, n, {
              value: Ae
            }),
            groupEnd: B({}, n, {
              value: De
            })
          });
        }
        G < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = D.ReactCurrentDispatcher, ce;
    function te(n, l, u) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (P) {
            var _ = P.stack.trim().match(/\n( *(at )?)/);
            ce = _ && _[1] || "";
          }
        return `
` + ce + n;
      }
    }
    var ue = !1, re;
    {
      var xt = typeof WeakMap == "function" ? WeakMap : Map;
      re = new xt();
    }
    function ke(n, l) {
      if (!n || ue)
        return "";
      {
        var u = re.get(n);
        if (u !== void 0)
          return u;
      }
      var _;
      ue = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var S;
      S = le.current, le.current = null, yt();
      try {
        if (l) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (L) {
              _ = L;
            }
            Reflect.construct(n, [], E);
          } else {
            try {
              E.call();
            } catch (L) {
              _ = L;
            }
            n.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (L) {
            _ = L;
          }
          n();
        }
      } catch (L) {
        if (L && _ && typeof L.stack == "string") {
          for (var b = L.stack.split(`
`), j = _.stack.split(`
`), w = b.length - 1, T = j.length - 1; w >= 1 && T >= 0 && b[w] !== j[T]; )
            T--;
          for (; w >= 1 && T >= 0; w--, T--)
            if (b[w] !== j[T]) {
              if (w !== 1 || T !== 1)
                do
                  if (w--, T--, T < 0 || b[w] !== j[T]) {
                    var O = `
` + b[w].replace(" at new ", " at ");
                    return n.displayName && O.includes("<anonymous>") && (O = O.replace("<anonymous>", n.displayName)), typeof n == "function" && re.set(n, O), O;
                  }
                while (w >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        ue = !1, le.current = S, Pt(), Error.prepareStackTrace = P;
      }
      var $ = n ? n.displayName || n.name : "", Xe = $ ? te($) : "";
      return typeof n == "function" && re.set(n, Xe), Xe;
    }
    function It(n, l, u) {
      return ke(n, !1);
    }
    function St(n) {
      var l = n.prototype;
      return !!(l && l.isReactComponent);
    }
    function ne(n, l, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return ke(n, St(n));
      if (typeof n == "string")
        return te(n);
      switch (n) {
        case g:
          return te("Suspense");
        case h:
          return te("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            return It(n.render);
          case p:
            return ne(n.type, l, u);
          case m: {
            var _ = n, P = _._payload, S = _._init;
            try {
              return ne(S(P), l, u);
            } catch {
            }
          }
        }
      return "";
    }
    var ie = Object.prototype.hasOwnProperty, Oe = {}, ze = D.ReactDebugCurrentFrame;
    function oe(n) {
      if (n) {
        var l = n._owner, u = ne(n.type, n._source, l ? l.type : null);
        ze.setExtraStackFrame(u);
      } else
        ze.setExtraStackFrame(null);
    }
    function wt(n, l, u, _, P) {
      {
        var S = Function.call.bind(ie);
        for (var E in n)
          if (S(n, E)) {
            var b = void 0;
            try {
              if (typeof n[E] != "function") {
                var j = Error((_ || "React class") + ": " + u + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw j.name = "Invariant Violation", j;
              }
              b = n[E](l, E, _, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              b = w;
            }
            b && !(b instanceof Error) && (oe(P), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", u, E, typeof b), oe(null)), b instanceof Error && !(b.message in Oe) && (Oe[b.message] = !0, oe(P), R("Failed %s type: %s", u, b.message), oe(null));
          }
      }
    }
    var Tt = Array.isArray;
    function fe(n) {
      return Tt(n);
    }
    function Rt(n) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, u = l && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function Ct(n) {
      try {
        return Ne(n), !1;
      } catch {
        return !0;
      }
    }
    function Ne(n) {
      return "" + n;
    }
    function Le(n) {
      if (Ct(n))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(n)), Ne(n);
    }
    var U = D.ReactCurrentOwner, Mt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, We, Be, de;
    de = {};
    function At(n) {
      if (ie.call(n, "ref")) {
        var l = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Dt(n) {
      if (ie.call(n, "key")) {
        var l = Object.getOwnPropertyDescriptor(n, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function jt(n, l) {
      if (typeof n.ref == "string" && U.current && l && U.current.stateNode !== l) {
        var u = N(U.current.type);
        de[u] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N(U.current.type), n.ref), de[u] = !0);
      }
    }
    function kt(n, l) {
      {
        var u = function() {
          We || (We = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Ot(n, l) {
      {
        var u = function() {
          Be || (Be = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var zt = function(n, l, u, _, P, S, E) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: n,
        key: l,
        ref: u,
        props: E,
        // Record the component responsible for creating this element.
        _owner: S
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Nt(n, l, u, _, P) {
      {
        var S, E = {}, b = null, j = null;
        u !== void 0 && (Le(u), b = "" + u), Dt(l) && (Le(l.key), b = "" + l.key), At(l) && (j = l.ref, jt(l, P));
        for (S in l)
          ie.call(l, S) && !Mt.hasOwnProperty(S) && (E[S] = l[S]);
        if (n && n.defaultProps) {
          var w = n.defaultProps;
          for (S in w)
            E[S] === void 0 && (E[S] = w[S]);
        }
        if (b || j) {
          var T = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          b && kt(E, T), j && Ot(E, T);
        }
        return zt(n, b, j, P, _, U.current, E);
      }
    }
    var he = D.ReactCurrentOwner, Ve = D.ReactDebugCurrentFrame;
    function F(n) {
      if (n) {
        var l = n._owner, u = ne(n.type, n._source, l ? l.type : null);
        Ve.setExtraStackFrame(u);
      } else
        Ve.setExtraStackFrame(null);
    }
    var _e;
    _e = !1;
    function ge(n) {
      return typeof n == "object" && n !== null && n.$$typeof === e;
    }
    function Fe() {
      {
        if (he.current) {
          var n = N(he.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Lt(n) {
      {
        if (n !== void 0) {
          var l = n.fileName.replace(/^.*[\\\/]/, ""), u = n.lineNumber;
          return `

Check your code at ` + l + ":" + u + ".";
        }
        return "";
      }
    }
    var $e = {};
    function Wt(n) {
      {
        var l = Fe();
        if (!l) {
          var u = typeof n == "string" ? n : n.displayName || n.name;
          u && (l = `

Check the top-level render call using <` + u + ">.");
        }
        return l;
      }
    }
    function Ye(n, l) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var u = Wt(l);
        if ($e[u])
          return;
        $e[u] = !0;
        var _ = "";
        n && n._owner && n._owner !== he.current && (_ = " It was passed a child from " + N(n._owner.type) + "."), F(n), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, _), F(null);
      }
    }
    function Ge(n, l) {
      {
        if (typeof n != "object")
          return;
        if (fe(n))
          for (var u = 0; u < n.length; u++) {
            var _ = n[u];
            ge(_) && Ye(_, l);
          }
        else if (ge(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var P = k(n);
          if (typeof P == "function" && P !== n.entries)
            for (var S = P.call(n), E; !(E = S.next()).done; )
              ge(E.value) && Ye(E.value, l);
        }
      }
    }
    function Bt(n) {
      {
        var l = n.type;
        if (l == null || typeof l == "string")
          return;
        var u;
        if (typeof l == "function")
          u = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === p))
          u = l.propTypes;
        else
          return;
        if (u) {
          var _ = N(l);
          wt(u, n.props, "prop", _, n);
        } else if (l.PropTypes !== void 0 && !_e) {
          _e = !0;
          var P = N(l);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(n) {
      {
        for (var l = Object.keys(n.props), u = 0; u < l.length; u++) {
          var _ = l[u];
          if (_ !== "children" && _ !== "key") {
            F(n), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _), F(null);
            break;
          }
        }
        n.ref !== null && (F(n), R("Invalid attribute `ref` supplied to `React.Fragment`."), F(null));
      }
    }
    function Ue(n, l, u, _, P, S) {
      {
        var E = bt(n);
        if (!E) {
          var b = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var j = Lt(P);
          j ? b += j : b += Fe();
          var w;
          n === null ? w = "null" : fe(n) ? w = "array" : n !== void 0 && n.$$typeof === e ? (w = "<" + (N(n.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : w = typeof n, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, b);
        }
        var T = Nt(n, l, u, P, S);
        if (T == null)
          return T;
        if (E) {
          var O = l.children;
          if (O !== void 0)
            if (_)
              if (fe(O)) {
                for (var $ = 0; $ < O.length; $++)
                  Ge(O[$], n);
                Object.freeze && Object.freeze(O);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ge(O, n);
        }
        return n === i ? Vt(T) : Bt(T), T;
      }
    }
    function Ft(n, l, u) {
      return Ue(n, l, u, !0);
    }
    function $t(n, l, u) {
      return Ue(n, l, u, !1);
    }
    var Yt = $t, Gt = Ft;
    q.Fragment = i, q.jsx = Yt, q.jsxs = Gt;
  }()), q;
}
process.env.NODE_ENV === "production" ? pe.exports = Kt() : pe.exports = Zt();
var v = pe.exports;
function Je(r, e) {
  var t = [];
  for (var i in r)
    e(r, i) && t.push(i);
  return t.concat(
    Object.getOwnPropertySymbols(r).filter(
      (o) => Object.getOwnPropertyDescriptor(r, o).enumerable
    )
  );
}
function st(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
function Qt(r, e) {
  return st(r, e) && r[e] !== void 0;
}
function Ke(r) {
  return r !== null && typeof r == "object" && typeof r.nodeType == "number" && typeof r.nodeName == "string" && typeof r.isEqualNode == "function";
}
function er(r, e) {
  return Object.prototype.toString.apply(e) === "[object " + r + "]";
}
function Ze(r) {
  return !!r && er("Function", r.asymmetricMatch);
}
function tr(r, e) {
  var t = Ze(r), i = Ze(e);
  if (!(t && i)) {
    if (t)
      return r.asymmetricMatch(e);
    if (i)
      return e.asymmetricMatch(r);
  }
}
const at = (r, e, t, i, o, a) => {
  o = o || [];
  var c = !0, d = tr(r, e);
  if (d !== void 0)
    return d;
  for (var f = 0; f < o.length; f++) {
    var g = o[f](r, e);
    if (g !== void 0)
      return g;
  }
  if (r instanceof Error && e instanceof Error)
    return r.message == e.message;
  if (Object.is(r, e))
    return !0;
  if (r === null || e === null)
    return r === e;
  var h = Object.prototype.toString.call(r);
  if (h != Object.prototype.toString.call(e))
    return !1;
  switch (h) {
    case "[object Boolean]":
    case "[object String]":
    case "[object Number]":
      return typeof r != typeof e ? !1 : typeof r != "object" && typeof e != "object" ? Object.is(r, e) : Object.is(r.valueOf(), e.valueOf());
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
      return r.source === e.source && r.flags === e.flags;
  }
  if (typeof r != "object" || typeof e != "object")
    return !1;
  if (Ke(r) && Ke(e))
    return r.isEqualNode(e);
  for (var p = t.length; p--; ) {
    if (t[p] === r)
      return i[p] === e;
    if (i[p] === e)
      return !1;
  }
  if (t.push(r), i.push(e), h == "[object Array]" && r.length !== e.length)
    return !1;
  var m = Je(r, a), y, A = m.length;
  if (Je(e, a).length !== A)
    return !1;
  for (; A--; )
    if (y = m[A], c = a(e, y) && at(r[y], e[y], t, i, o, a), !c)
      return !1;
  return t.pop(), i.pop(), c;
};
function rr(r, e, t, i) {
  const o = (i == null ? void 0 : i.customTesters) || [];
  return at(r, e, [], [], o, t ? st : Qt);
}
function be() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function lt() {
  try {
    return document.createEvent("MouseEvent"), !0;
  } catch {
    return !1;
  }
}
function Qe(r, e = 0) {
  const t = Number(r);
  return isNaN(t) ? e : t;
}
function ct(r = 0, e = []) {
  const t = e.filter((i) => i < r).sort((i, o) => Number(o) - Number(i));
  return t.length > 0 ? t[0] : 0;
}
function nr(r) {
  var t;
  const e = r.match(/matrix.*\((.+?)\)/);
  return e === null ? [] : (t = e[1]) == null ? void 0 : t.split(", ").map(Number);
}
function ir(r) {
  return Math.floor(r * 100) / 100;
}
function H(r) {
  return Object.keys(r);
}
function or(r, e, t) {
  const i = H(r).filter((a) => typeof r[a] != "function" && !t.includes(a)).map((a) => r[a]), o = H(e).filter((a) => typeof e[a] != "function" && !t.includes(a)).map((a) => e[a]);
  return rr(i, o) === !1;
}
function sr(r, e) {
  const t = r == null ? void 0 : r.map((o) => o.key).join("_"), i = e == null ? void 0 : e.map((o) => o.key).join("_");
  return t !== i;
}
function W(r, e = "") {
  if (r)
    return String(e);
}
function ar(r, e) {
  const t = r % 1, i = Math.floor(r);
  return t >= e ? i + 1 : i;
}
function lr(r, e) {
  const t = r % 1, i = Math.floor(r);
  let o = i + 1;
  return t <= 1 - e && (o = i), o < 0 ? 0 : o;
}
const x = {
  console: "bear-react-carousel__console",
  root: "bear-react-carousel__root",
  content: "bear-react-carousel__content",
  container: "bear-react-carousel__container",
  containerInit: "bear-react-carousel__container-init",
  slideItem: "bear-react-carousel__slide-item",
  slideItemImage: "bear-react-carousel__slide-item__image",
  slideItemImageCover: "bear-react-carousel__slide-item__image-cover",
  slideItemImageContain: "bear-react-carousel__slide-item__image-contain",
  slideItemImageScaleDown: "bear-react-carousel__slide-item__image-scale-down",
  slideItemImageNone: "bear-react-carousel__slide-item__image-none",
  slideItemImagePreLoad: "bear-react-carousel__slide-item__image-preload",
  slideItemCard: "bear-react-carousel__slide-item__card",
  slideItemCardCover: "bear-react-carousel__slide-item__card-cover",
  slideItemCardContain: "bear-react-carousel__slide-item__card-contain",
  slideItemCard100: "bear-react-carousel__slide-item__card-100",
  navGroup: "bear-react-carousel__nav-group",
  navButton: "bear-react-carousel__nav-button",
  navPrevButton: "bear-react-carousel__nav-prev-button",
  navNextButton: "bear-react-carousel__nav-next-button",
  navIcon: "bear-react-carousel__nav-icon",
  paginationGroup: "bear-react-carousel__pagination-group",
  paginationButton: "bear-react-carousel__pagination-button",
  paginationContent: "bear-react-carousel__pagination-content",
  testNumber: "bear-react-carousel__test-number",
  testWindowSize: "bear-react-carousel__window-size",
  cloneIconGroup: "bear-react-carousel__clone-icon-group",
  cloneIcon: "bear-react-carousel__clone-icon"
}, K = [
  "color: #fff",
  "display: block",
  "line-height: 20px",
  "padding-right: 8px"
];
function Z(r, e, t) {
  console.log(`%c ${r}`, e, t);
}
function cr(r, e) {
  const t = K.concat([
    "background-color: #007bff"
  ]).join(";");
  Z(r, t, e);
}
function ur(r, e) {
  const t = K.concat([
    "background-color: #28a745"
  ]).join(";");
  Z(r, t, e);
}
function ut(r, e) {
  const t = K.concat([
    "background-color: #17a2b8"
  ]).join(";");
  Z(r, t, e);
}
function fr(r, e) {
  const t = K.concat([
    "background-color: #ffc107"
  ]).join(";");
  Z(r, t, e);
}
function dr(r, e) {
  const t = K.concat([
    "background-color: #ec2127"
  ]).join(";");
  Z(r, t, e);
}
function hr(r, e = !0) {
  const t = document.getElementById(x.console);
  if (t) {
    const i = /* @__PURE__ */ new Date(), o = [i.getMinutes(), i.getSeconds()].join("");
    t.value = `${o}: ${r}
${t.value}`;
  } else
    e && ut("mobile", r);
}
const C = {
  primary: cr,
  success: ur,
  info: ut,
  warning: fr,
  danger: dr,
  printInText: hr
};
function me(r) {
  return {
    slidesPerView: r.slidesPerView,
    slidesPerGroup: r.slidesPerGroup,
    slidesPerViewActual: 0,
    height: r.height,
    spaceBetween: r.spaceBetween,
    isCenteredSlides: r.isCenteredSlides,
    isEnableNavButton: r.isEnableNavButton,
    isEnablePagination: r.isEnablePagination,
    isEnablePageContent: r.isEnablePageContent,
    isEnableMouseMove: r.isEnableMouseMove,
    isEnableAutoPlay: r.isEnableAutoPlay,
    isEnableLoop: r.isEnableLoop,
    moveTime: r.moveTime,
    autoPlayTime: r.autoPlayTime,
    initStartPlayTime: r.initStartPlayTime,
    moveEffect: r.moveEffect,
    isDebug: r.isDebug
  };
}
function et(r) {
  const e = r == null ? void 0 : r.breakpoints, t = r == null ? void 0 : r.win, i = r == null ? void 0 : r.defaultBreakpoint, o = e && t ? ct(t == null ? void 0 : t.innerWidth, H(e).map(Number)) : 0;
  let a = i ?? {
    slidesPerView: 1,
    slidesPerGroup: 1
  };
  e && o > 0 && (a = Object.assign(a, e[o]));
  const c = a.slidesPerView === "auto" ? 1 : Qe(a.slidesPerView, 1);
  return {
    ...a,
    slidesPerViewActual: c,
    isEnableLoop: a.slidesPerView === "auto" ? !1 : a.isEnableLoop,
    slidesPerGroup: a.slidesPerGroup > c ? c : Qe(a.slidesPerGroup, 1)
    // fix
  };
}
function _r(r) {
  if (typeof r == "string")
    return r === "auto" ? void 0 : { height: r };
  if (typeof (r == null ? void 0 : r.widthRatio) < "u" && typeof (r == null ? void 0 : r.heightRatio) < "u")
    return {
      aspectRatio: `${r.widthRatio} / ${r.heightRatio}`,
      height: "auto"
    };
}
class gr {
  constructor(e) {
    s(this, "_setting");
    s(this, "_window");
    s(this, "init", (e) => {
      this._setting = et({
        defaultBreakpoint: e.defaultBreakpoint,
        breakpoints: e.breakpoints,
        win: this._window
      });
    });
    this._window = e.win, this._setting = et(e);
  }
  get setting() {
    return this._setting;
  }
  get isAutoHeight() {
    return typeof this.setting.height > "u" || this.setting.height === "auto";
  }
  get rootHeight() {
    return _r(this.setting.height);
  }
  get style() {
    var t, i;
    return {
      "--carousel-height": (t = this.rootHeight) == null ? void 0 : t.height,
      "--carousel-aspect-ratio": (i = this.rootHeight) == null ? void 0 : i.aspectRatio,
      "--carousel-content-position": this.isAutoHeight ? "static" : "absolute",
      // 保護不被項目擠開
      "--carousel-space-between": `${this.setting.spaceBetween}px`,
      "--carousel-slide-width": this.setting.slidesPerView === "auto" ? "auto" : `${100 / this.setting.slidesPerViewActual}%`
    };
  }
}
class Q {
  constructor() {
    s(this, "events", /* @__PURE__ */ new Map());
  }
  on(e, t) {
    this.events.has(e) || this.events.set(e, []), this.events.get(e).push(t);
  }
  off(e, t) {
    if (this.events.has(e) && t) {
      const i = this.events.get(e), o = i.indexOf(t);
      o >= 0 && i.splice(o, 1);
    }
  }
  emit(e, ...t) {
    if (this.events.has(e))
      for (const i of this.events.get(e))
        i && i(...t);
  }
}
var z = /* @__PURE__ */ ((r) => (r[r.mobile = 0] = "mobile", r[r.desktop = 1] = "desktop", r))(z || {});
const M = {
  componentDidMount: !0,
  componentWillUnmount: !0,
  shouldComponentUpdate: !0,
  dragger: {
    onMobileTouchStart: !0,
    onMobileTouchMove: !0,
    onMobileTouchEnd: !0,
    onWebMouseStart: !0,
    onWebMouseMove: !0,
    onWebMouseEnd: !0,
    onDragMove: !1,
    onDragEnd: !1
  },
  controller: {
    onSlideResetToMatchIndex: !0
  },
  autoPlayer: {
    play: !0,
    pause: !0
  },
  windowSizer: {
    onResize: !0
  },
  syncCarousel: {
    onSyncControlMove: !1,
    onSyncControlDone: !1,
    onSlideToSourceIndex: !1
  }
}, se = {
  [z.mobile]: "orientationchange",
  [z.desktop]: "resize"
};
class mr {
  constructor(e) {
    s(this, "_breakpoints");
    s(this, "_configurator");
    s(this, "_size");
    s(this, "_device");
    s(this, "_eventManager", new Q());
    s(this, "_window");
    s(this, "_currWidth");
    s(this, "_detectDevice", () => be() ? z.mobile : (lt(), z.desktop));
    s(this, "_setSize", () => ct(this._window.innerWidth, this._breakpoints ? H(this._breakpoints).map(Number) : void 0));
    s(this, "_emitResize", () => {
      this._configurator.setting.isDebug && M.windowSizer.onResize && C.printInText("[WindowSizer.onResize]"), this._currWidth !== this._window.innerWidth && (this._currWidth = this._window.innerWidth, this._size = this._setSize(), this._eventManager.emit("resize", { windowSize: this._size }));
    });
    s(this, "onResize", (e) => {
      this._device === z.mobile && this._window.addEventListener(se[z.mobile], this._emitResize, !1), this._window.addEventListener(se[z.desktop], this._emitResize, !1), this._eventManager.on("resize", e);
    });
    s(this, "offResize", (e) => {
      this._device === z.mobile && this._window.removeEventListener(se[z.mobile], this._emitResize, !1), this._window.removeEventListener(se[z.desktop], this._emitResize, !1), this._eventManager.off("resize", e);
    });
    this._breakpoints = e.breakpoints, this._configurator = e.configurator, this._window = e.win, this._device = this._detectDevice(), this._size = this._setSize(), this._currWidth = this._window.innerWidth;
  }
  get size() {
    return this._size;
  }
  get device() {
    return this._device;
  }
}
function tt(r = [], e = 1, t = 1, i = !1) {
  const o = [], a = i;
  let c = 0;
  const f = e === "auto" ? 0 : Math.ceil(e * 1.5), g = r.length / t - (t - f);
  if (a) {
    const m = r.length - f;
    for (const [y, A] of r.slice(-f).entries())
      o[c] = {
        key: `clone_before_${y}`,
        virtualIndex: c,
        matchIndex: f + m + c,
        sourceIndex: m + y,
        inPage: g,
        isClone: !0,
        element: A.children
      }, c += 1;
  }
  let h = c, p = 0;
  for (const [m, y] of r.entries())
    o[c] = {
      key: `source_${m}`,
      virtualIndex: c,
      matchIndex: c,
      sourceIndex: m,
      inPage: Math.ceil((p + 1) / t),
      isClone: !1,
      element: y.children
    }, c += 1, p += 1;
  if (a)
    for (const [m, y] of r.slice(0, f).entries())
      o[c] = {
        key: `clone_after_${m}`,
        virtualIndex: c,
        matchIndex: h,
        sourceIndex: m,
        inPage: 1,
        isClone: !0,
        element: y.children
      }, c += 1, h += 1;
  return o;
}
function vr(r, e, t, i) {
  return r ? e + t : e + i;
}
function pr(r, e, t, i) {
  if (r) {
    const a = e - t;
    return a < 0 ? 0 : a;
  }
  const o = e - i;
  return o < 0 ? 0 : o;
}
function Ee(r, e) {
  return r >= e.virtual.lastIndex ? e.virtual.lastIndex : r <= 0 ? 0 : r;
}
function br(r, e) {
  const t = Math.abs(r.y - e.y), i = Math.abs(r.x - e.x);
  return t < i;
}
class Er {
  constructor(e, t) {
    s(this, "_info");
    s(this, "_formatElement");
    s(this, "_configurator");
    s(this, "_eventor", new Q());
    s(this, "reset", (e = []) => {
      this._info = this.formatInfo(e), this._eventor.emit("change");
    });
    s(this, "onChange", (e) => {
      this._eventor.on("change", e);
    });
    s(this, "offChange", (e) => {
      this._eventor.off("change", e);
    });
    /**
     * 確認是否超出範圍
     * @param index
     */
    s(this, "getInRangeIndex", (e) => Ee(e, this));
    s(this, "formatInfo", (e = []) => {
      const { slidesPerView: t, slidesPerViewActual: i, slidesPerGroup: o, isCenteredSlides: a, isEnablePagination: c, isEnableNavButton: d, isEnableLoop: f } = this._configurator.setting;
      let g = e.length;
      this.updateData(e);
      const h = this.formatElement.length, p = { min: 0, max: h - 1 };
      let m = Math.ceil(g / o);
      const y = !(f || a || t === "auto" || !Number.isInteger(t));
      return y && (m = m - (t - o)), {
        // 從0開始
        source: {
          activeIndex: 0,
          lastIndex: g - 1,
          total: g
        },
        // 0為實際一開始的位置(往前為負數), 結束值為最後結束位置
        virtual: {
          activeIndex: 0,
          lastIndex: y ? Math.ceil(p.max - (this._configurator.setting.slidesPerViewActual - 1)) : p.max,
          total: this._formatElement.length
        },
        page: {
          activePage: 1,
          total: m > 0 ? m : 1
        },
        // 總頁數
        residue: h % o,
        isVisiblePagination: !!(c && this.formatElement.length > 0),
        isVisibleNavButton: !!(d && this.formatElement.length > 0)
      };
    });
    s(this, "updateData", (e = []) => {
      const { slidesPerViewActual: t, slidesPerGroup: i, isEnableLoop: o } = this._configurator.setting;
      this._formatElement = tt(
        e,
        t,
        i,
        o
      );
    });
    s(this, "setActiveActual", (e, t) => {
      var i;
      this.virtual.activeIndex !== e && (this.source.activeIndex = ((i = this.formatElement[e]) == null ? void 0 : i.sourceIndex) ?? 0, this.virtual.activeIndex = e, this.page.activePage = t, this._eventor.emit("change"));
    });
    this._configurator = e, this._info = this.formatInfo(t);
    const { slidesPerViewActual: i, slidesPerGroup: o, isEnableLoop: a } = this._configurator.setting;
    this._formatElement = tt(
      t,
      i,
      o,
      a
    ), this._eventor.emit("change");
  }
  get nextPage() {
    return this._info.page.activePage + 1;
  }
  get nextPageFirstIndex() {
    const { setting: e } = this._configurator;
    return vr(e.isCenteredSlides ?? !1, this.virtual.activeIndex, e.slidesPerGroup, e.slidesPerViewActual);
  }
  get prevPage() {
    var e;
    return ((e = this._info) == null ? void 0 : e.page.activePage) - 1;
  }
  get prevPageFirstIndex() {
    const { setting: e } = this._configurator;
    return pr(e.isCenteredSlides ?? !1, this.virtual.activeIndex, e.slidesPerGroup, e.slidesPerViewActual);
  }
  get virtual() {
    var e;
    return (e = this._info) == null ? void 0 : e.virtual;
  }
  get page() {
    var e;
    return (e = this._info) == null ? void 0 : e.page;
  }
  get formatElement() {
    return this._formatElement;
  }
  get source() {
    var e;
    return (e = this._info) == null ? void 0 : e.source;
  }
  get residue() {
    var e;
    return ((e = this._info) == null ? void 0 : e.residue) ?? 0;
  }
  get isVisibleNavButton() {
    var e;
    return (e = this._info) == null ? void 0 : e.isVisibleNavButton;
  }
  get isVisiblePagination() {
    var e;
    return (e = this._info) == null ? void 0 : e.isVisiblePagination;
  }
}
const yr = () => /* @__PURE__ */ v.jsxs("svg", { className: "icon", viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", children: [
  /* @__PURE__ */ v.jsx(
    "path",
    {
      d: "M808.768 197.312c10.432 0 17.408 6.912 17.408 17.344l0 485.568c0 10.368-6.976 17.344-17.408 17.344l-87.296 0c-19.136 0-34.944 15.552-34.944 34.624 0 19.136 15.808 34.688 34.944 34.688l104.768 0c38.464 0 69.824-31.168 69.824-69.312l0-520.32C896 159.168 864.64 128 826.176 128l-384 0c-38.4 0-69.824 31.232-69.824 69.312l0 34.688c0 19.072 15.68 34.688 34.88 34.688 19.2 0 34.88-15.616 34.88-34.688L442.112 214.656c0-10.432 6.976-17.344 17.408-17.344L808.768 197.312z",
      fill: "#ffffff"
    }
  ),
  /* @__PURE__ */ v.jsx(
    "path",
    {
      d: "M128 363.968l0 469.376C128 867.84 160.32 896 199.808 896l394.944 0c39.488 0 71.872-28.16 71.872-62.656L666.624 363.968c0-34.432-32.384-62.592-71.872-62.592L199.808 301.376C160.32 301.376 128 329.536 128 363.968z",
      fill: "#ffffff"
    }
  )
] }), Pr = ye(({
  element: r,
  index: e,
  virtualIndex: t,
  matchIndex: i,
  sourceIndex: o,
  inPage: a,
  isActive: c = !1,
  isClone: d = !1,
  isDebug: f = !1
}, g) => /* @__PURE__ */ v.jsxs(
  "div",
  {
    className: x.slideItem,
    ref: g,
    "data-testid": "bear-carousel-slideItem",
    "data-virtual": t,
    "data-match": W(d, i),
    "data-page": a,
    "data-source": o,
    "data-active": W(c),
    "data-is-clone": W(d),
    children: [
      r,
      f && /* @__PURE__ */ v.jsxs("div", { className: x.testNumber, children: [
        o,
        d && /* @__PURE__ */ v.jsxs("div", { className: x.cloneIconGroup, children: [
          /* @__PURE__ */ v.jsx("div", { className: x.cloneIcon, children: /* @__PURE__ */ v.jsx(yr, {}) }),
          e
        ] })
      ] })
    ]
  }
));
class xr {
  constructor(e) {
    s(this, "_rootRef", Y());
    s(this, "_containerRef", Y());
    s(this, "_pageGroupRef", Y());
    s(this, "_navGroupRef", Y());
    s(this, "_slideItemRefs", Y());
    s(this, "_pageRefs", Y());
    this._slideItemRefs.current = [], this._pageRefs.current = [];
  }
  get rootEl() {
    return this._rootRef.current;
  }
  get containerEl() {
    return this._containerRef.current;
  }
  get slideItemEls() {
    return this._slideItemRefs.current;
  }
  get pageEls() {
    return this._pageRefs.current;
  }
  get pageGroupEl() {
    return this._pageGroupRef.current;
  }
  get navGroupEl() {
    return this._navGroupRef.current;
  }
  setSlideItemRefs(e, t) {
    this._slideItemRefs.current && (this._slideItemRefs.current[t] = e);
  }
  setPageRefs(e, t) {
    this._pageRefs.current && (this._pageRefs.current[t] = e);
  }
}
function Ir(r, e) {
  return (r - 1) * e;
}
function Sr(r, e, t) {
  const i = e.formatElement[e.virtual.activeIndex], { setting: o } = t;
  if (i) {
    if (o.isEnableLoop)
      return i.isClone ? r.isAnimation ? [] : [
        { index: i.matchIndex, isUseAnimation: !1 },
        { index: i.matchIndex - 1, isUseAnimation: !0 }
      ] : e.residue > 0 ? [
        { index: i.virtualIndex - e.residue, isUseAnimation: !0 }
      ] : [
        { index: i.virtualIndex - o.slidesPerGroup, isUseAnimation: !0 }
      ];
    if (e.virtual.activeIndex > 0)
      return [
        { index: i.virtualIndex - o.slidesPerGroup, isUseAnimation: !0 }
      ];
  }
  return [];
}
function wr(r, e, t) {
  const i = e.formatElement[e.virtual.activeIndex], { setting: o } = t;
  if (i) {
    if (o.isEnableLoop)
      return i != null && i.isClone ? r.isAnimation ? [] : [
        { index: i.matchIndex, isUseAnimation: !1 },
        { index: i.matchIndex + o.slidesPerGroup, isUseAnimation: !0 }
      ] : e.residue > 0 ? [
        { index: i.virtualIndex + e.residue, isUseAnimation: !0 }
      ] : [
        { index: i.virtualIndex + o.slidesPerGroup, isUseAnimation: !0 }
      ];
    if (e.virtual.activeIndex <= e.virtual.lastIndex)
      return [
        { index: i.virtualIndex + o.slidesPerGroup, isUseAnimation: !0 }
      ];
  }
  return [];
}
class Tr {
  constructor(e) {
    s(this, "_configurator");
    s(this, "_stater");
    s(this, "_elState");
    s(this, "_eventor", new Q());
    s(this, "onSlideBefore", (e) => {
      this._eventor.on("slideBefore", e);
    });
    s(this, "onSlideAfter", (e) => {
      this._eventor.on("slideAfter", e);
    });
    s(this, "offSlideBefore", (e) => {
      this._eventor.off("slideBefore", e);
    });
    s(this, "offSlideAfter", (e) => {
      this._eventor.off("slideAfter", e);
    });
    /**
     * reset page position (Only LoopMode)
     * PS: If the element is isClone then return to the position where it should actually be displayed
     */
    s(this, "slideResetToMatchIndex", () => {
      var i;
      this._configurator.setting.isDebug && M.controller.onSlideResetToMatchIndex && C.printInText("[Controller.slideResetToMatchIndex]");
      const { virtual: e, formatElement: t } = this._stater;
      (i = t[e.activeIndex]) != null && i.isClone && this.slideToVirtualIndex(t[e.activeIndex].matchIndex, { isUseAnimation: !1 });
    });
    /**
     * 包含 Clone 的 Index
     * @param slideIndex
     * @param options
     */
    s(this, "slideToSourceIndex", (e, t) => {
      ((t == null ? void 0 : t.isEmitEvent) ?? !0) && this._eventor.emit("slideBefore", e, (t == null ? void 0 : t.isUseAnimation) ?? !1);
      const o = this._stater.formatElement.find((a) => a.sourceIndex === e && !a.isClone);
      o && this.slideToVirtualIndex(o.virtualIndex, t);
    });
    /**
     * 包含 Clone 的 Index
     * @param slideIndex
     * @param options
     */
    s(this, "slideToVirtualIndex", (e, t) => {
      var d;
      const i = (t == null ? void 0 : t.isEmitEvent) ?? !0;
      i && this._eventor.emit("slideBefore", e, (t == null ? void 0 : t.isUseAnimation) ?? !1);
      const o = this._stater.getInRangeIndex(e), { formatElement: a } = this._stater;
      this._stater.setActiveActual(o, ((d = a[o]) == null ? void 0 : d.inPage) ?? 1);
      const c = this._elState.getMoveDistance(o);
      this._elState.transform(c, (t == null ? void 0 : t.isUseAnimation) ?? !0).moveEffect(e, (t == null ? void 0 : t.isUseAnimation) ?? !0).syncActiveState(), i && this._eventor.emit("slideAfter", o, t == null ? void 0 : t.isUseAnimation);
    });
    /**
     * 移動到下一頁
     */
    s(this, "slideToNextPage", () => {
      wr(this._elState, this._stater, this._configurator).forEach((e) => this.slideToVirtualIndex(e.index, { isUseAnimation: e.isUseAnimation }));
    });
    /**
     * go to previous
     */
    s(this, "slideToPrevPage", () => {
      Sr(this._elState, this._stater, this._configurator).forEach((e) => this.slideToVirtualIndex(e.index, { isUseAnimation: e.isUseAnimation }));
    });
    this._configurator = e.configurator, this._stater = e.stater, this._elState = e.elState;
  }
  /**
   * 移動到指定頁面
   * @param page
   * @param isUseAnimation 是否開啟動畫
   * ex: slideView: 2, slideGroup: 2, total: 4
   * page1 -> (1-1) * 2) + 1 + (firstIndex -1) = 1
   */
  slideToPage(e, t = !0) {
    var a, c;
    const { setting: i } = this._configurator;
    e = e > ((a = this._stater.page) == null ? void 0 : a.total) ? (c = this._stater.page) == null ? void 0 : c.total : e;
    const o = Ir(e, i.slidesPerGroup);
    this.slideToSourceIndex(o, { isUseAnimation: t });
  }
}
class Rr {
  constructor(e) {
    s(this, "_configurator");
    s(this, "_timer", null);
    s(this, "_initTimer", null);
    s(this, "_eventor", new Q());
    s(this, "onTimeout", (e) => {
      window.addEventListener("focus", this.play, !1), window.addEventListener("blur", this.pause, !1), this._initTimer = setTimeout(this.play, this._configurator.setting.initStartPlayTime ?? 0), this._eventor.on("timeout", e);
    });
    /**
     * 完全移除
     */
    s(this, "offTimeout", (e) => {
      window.removeEventListener("focus", this.play, !1), window.removeEventListener("blur", this.pause, !1), this.pause(), this._eventor.off("timeout", e);
    });
    s(this, "play", () => {
      const { setting: e } = this._configurator;
      e.isDebug && M.autoPlayer.play && C.printInText("[AutoPlayer.play]"), !this.isPlaying && e.isEnableAutoPlay && ((e == null ? void 0 : e.autoPlayTime) ?? 0) > 0 && (this._timer = setInterval(() => {
        this._eventor.emit("timeout");
      }, e.autoPlayTime));
    });
    s(this, "pause", () => {
      this._configurator.setting.isDebug && M.autoPlayer.play && C.printInText("[AutoPlayer.pause]"), this._timer && (clearInterval(this._timer), this._timer = null), this._initTimer && (clearInterval(this._initTimer), this._initTimer = null);
    });
    this._configurator = e.configurator;
  }
  get isPlaying() {
    return this._timer;
  }
}
function Cr(r, e) {
  return e - r;
}
function Mr(r) {
  const t = window.getComputedStyle(r).transform, i = t.includes("3d") ? "3d" : "2d";
  let o = nr(t);
  switch (i) {
    case "2d":
      return { x: o[4] ?? 0, y: o[5] ?? 0, z: 0 };
    case "3d":
      return { x: o[12] ?? 0, y: o[13] ?? 0, z: o[14] };
    default:
      return { x: 0, y: 0, z: 0 };
  }
}
const Ar = {
  pageX: 0,
  pageY: 0,
  x: 0,
  y: 0,
  timeStamp: null
}, Dr = {
  pageX: 0,
  pageY: 0,
  x: 0,
  y: 0,
  timeStamp: null,
  // 不使用, 直接 End 使用 Date.now()
  moveX: 0,
  moveY: 0
};
class jr {
  constructor() {
    s(this, "_startPosition", Ar);
    s(this, "_endPosition", Dr);
    s(this, "_letItGo", null);
    s(this, "touchStart", (e, t) => {
      const { x: i, y: o } = Mr(t);
      this._startPosition.x = e.pageX - i, this._startPosition.y = e.pageY - o, this._startPosition.pageX = e.pageX, this._startPosition.pageY = e.pageY, this._startPosition.timeStamp = Date.now(), this._endPosition = {
        timeStamp: null,
        pageX: e.pageX,
        pageY: e.pageY,
        x: i,
        y: o,
        moveX: this._startPosition.pageX - this._startPosition.x,
        moveY: this._startPosition.pageY - this._startPosition.y
      };
    });
    s(this, "touchMove", (e, t) => {
      const i = this._startPosition.x;
      this._endPosition.pageX = e.pageX;
      const o = this._startPosition.y;
      return this._endPosition.pageY = e.pageY, this._endPosition.moveX = this._endPosition.pageX - i, this._endPosition.moveY = this._endPosition.pageY - o, {
        x: this._endPosition.moveX,
        y: this._endPosition.moveY
      };
    });
  }
  get startPosition() {
    return this._startPosition;
  }
}
class rt {
  constructor(e) {
    s(this, "_event");
    this._event = e;
  }
  get pageX() {
    return this._event.touches[0].pageX ?? 0;
  }
  get pageY() {
    return this._event.touches[0].pageY ?? 0;
  }
}
class nt {
  constructor(e) {
    s(this, "_event");
    this._event = e;
  }
  get pageX() {
    return this._event.pageX;
  }
  get pageY() {
    return this._event.pageY;
  }
}
class kr {
  // 最少滑動多少距離Px才檢查比例切換上下頁
  constructor(e) {
    s(this, "_configurator");
    s(this, "_elementor");
    s(this, "_elState");
    s(this, "_locator");
    s(this, "_stater");
    s(this, "_eventor", new Q());
    s(this, "_moveMinDistancePx", 50);
    s(this, "onDragStart", (e) => {
      this._elementor.containerEl && (be() ? this._elementor.containerEl.addEventListener("touchstart", this._onMobileTouchStart, { passive: !1 }) : this._elementor.containerEl.addEventListener("pointerdown", this._onWebMouseStart, { passive: !1 })), this._eventor.on("dragStart", e);
    });
    s(this, "onDragMove", (e) => {
      this._eventor.on("dragMove", e);
    });
    s(this, "onDragEnd", (e) => {
      this._eventor.on("dragEnd", e);
    });
    s(this, "offDragStart", (e) => {
      this._elementor.containerEl && (be() ? this._elementor.containerEl.removeEventListener("touchstart", this._onMobileTouchStart, { passive: !1 }) : this._elementor.containerEl.removeEventListener("pointerdown", this._onWebMouseStart, { passive: !1 })), this._eventor.off("dragStart", e);
    });
    s(this, "offDragMove", (e) => {
      this._eventor.off("dragMove", e);
    });
    s(this, "offDragEnd", (e) => {
      this._eventor.off("dragEnd", e);
    });
    /**
     * mobile phone finger press start
     * @param event
     */
    s(this, "_onMobileTouchStart", (e) => {
      this._configurator.setting.isDebug && M.dragger.onMobileTouchStart && C.printInText("[Dragger._onMobileTouchStart]"), e.stopPropagation(), this._eventor.emit("dragStart");
      const { containerEl: t } = this._elementor;
      t && (this._locator.touchStart(new rt(e), t), document.addEventListener("touchmove", this._onMobileTouchMove, { passive: !1 }), document.addEventListener("touchend", this._onMobileTouchEnd, { passive: !1 }));
    });
    /**
     * Mobile phone finger press and move
     * @param event
     */
    s(this, "_onMobileTouchMove", (e) => {
      e.stopPropagation();
      const t = new rt(e);
      if (this._configurator.setting.isDebug && M.dragger.onMobileTouchMove && C.printInText("[Dragger._onMobileTouchMove]"), this._locator._letItGo === null && (this._locator._letItGo = br({
        x: this._locator.startPosition.pageX,
        y: this._locator.startPosition.pageY
      }, {
        x: t.pageX,
        y: t.pageY
      })), this._elementor.containerEl && this._locator._letItGo) {
        e.preventDefault();
        const i = this._locator.touchMove(t, this._elementor.containerEl);
        this._dragMove(i.x);
      }
    });
    /**
     * Mobile phone finger press to end
     * @param event
     *
     * PS: Add event.preventDefault(); will affect the mobile phone click onClick event
     */
    s(this, "_onMobileTouchEnd", (e) => {
      this._configurator.setting.isDebug && M.dragger.onMobileTouchEnd && C.printInText("[Dragger._onMobileTouchEnd]"), e.stopPropagation(), this._locator._letItGo = null;
      const { containerEl: t } = this._elementor;
      t && (document.removeEventListener("touchmove", this._onMobileTouchMove, !1), document.removeEventListener("touchend", this._onMobileTouchEnd, !1)), this._dragEnd();
    });
    /**
     * Web mouse click
     * @param event
     */
    s(this, "_onWebMouseStart", (e) => {
      e.preventDefault(), this._configurator.setting.isDebug && M.dragger.onWebMouseStart && C.printInText("[Dragger._onWebMouseStart]"), this._eventor.emit("dragStart");
      const { containerEl: t } = this._elementor;
      if (t) {
        this._locator.touchStart(new nt(e), t);
        const { startPosition: i } = this._locator, o = Cr(i.x, e.clientX);
        this._elState.transform(o, !1), document.addEventListener("pointermove", this._onWebMouseMove, !1), document.addEventListener("pointerup", this._onWebMouseEnd, !1), document.addEventListener("pointercancel", this._onWebMouseEnd, !1);
      }
    });
    /**
     * Web mouse movement
     * @param event
     */
    s(this, "_onWebMouseMove", (e) => {
      if (e.preventDefault(), this._configurator.setting.isDebug && M.dragger.onWebMouseMove && C.printInText("[Dragger._onWebMouseMove]"), this._elState.setTouching(!0), this._elementor.containerEl) {
        this._elementor.containerEl.setPointerCapture(e.pointerId);
        const t = this._locator.touchMove(new nt(e), this._elementor.containerEl);
        this._dragMove(t.x);
      }
    });
    /**
     * web mouse release
     * @param event
     */
    s(this, "_onWebMouseEnd", (e) => {
      e.preventDefault(), this._configurator.setting.isDebug && M.dragger.onWebMouseEnd && C.printInText("[Dragger._onWebMouseEnd]"), document.removeEventListener("pointermove", this._onWebMouseMove, !1), document.removeEventListener("pointerup", this._onWebMouseEnd, !1), document.removeEventListener("pointercancel", this._onWebMouseEnd, !1), this._dragEnd();
    });
    /**
     * The object movement ends (confirm the stop position and which Index position should be sucked)
     */
    s(this, "_dragEnd", () => {
      var o;
      this._configurator.setting.isDebug && M.dragger.onDragEnd && C.printInText("[Dragger._dragEnd]"), this._elState.setTouching(!1);
      const e = this._elState.getMovePercentage(this._locator._endPosition.moveX), t = this._locator._endPosition.pageX - this._locator._startPosition.pageX, i = this._configurator.setting.movePercentage ?? 0.33;
      if (t > 0) {
        const a = Ee(lr(e, i), this._stater);
        this._eventor.emit("dragEnd", a);
      } else if (t < 0) {
        const a = Ee(ar(e, i), this._stater);
        this._eventor.emit("dragEnd", a);
      } else
        this._eventor.emit("dragEnd", (o = this._stater.virtual) == null ? void 0 : o.activeIndex);
    });
    this._configurator = e.configurator, this._elementor = e.elementor, this._elState = e.elState, this._stater = e.stater, this._locator = new jr();
  }
  _dragMove(e) {
    this._configurator.setting.isDebug && M.dragger.onDragMove && C.printInText("[Dragger._dragMove]");
    const { setting: t } = this._configurator;
    if (this._elementor.containerEl && t.isEnableMouseMove && this._elementor.slideItemEls && this._stater.page.total > 1) {
      const i = this._elState.getMovePercentage(e);
      this._eventor.emit("dragMove", i), this._elState.transform(e).moveEffect(i).syncActiveState();
    }
  }
}
class Or {
  constructor(e) {
    s(this, "_carouselRef");
    s(this, "syncControlMove", (e) => {
      var t;
      if ((t = this._configurator) != null && t.setting.isDebug && M.syncCarousel.onSyncControlMove && C.printInText("[SyncCarousel.syncControlMove]"), this._elementor) {
        const i = this._elementor.getPercentageToMovePx(e);
        this._elementor.transform(i).moveEffect(e).syncActiveState();
      }
    });
    s(this, "syncControlDone", (e) => {
      var t, i;
      (t = this._configurator) != null && t.setting.isDebug && M.syncCarousel.onSyncControlDone && C.printInText("[SyncCarousel.syncControlDone]"), (i = this._controller) == null || i.slideToVirtualIndex(e);
    });
    s(this, "slideToSourceIndex", (e, t = !0) => {
      var i, o;
      (i = this._configurator) != null && i.setting.isDebug && M.syncCarousel.onSlideToSourceIndex && C.printInText("[SyncCarousel.slideToSourceIndex]"), (o = this._controller) == null || o.slideToSourceIndex(e, { isUseAnimation: t, isEmitEvent: !1 });
    });
    this._carouselRef = e;
  }
  get _elementor() {
    var e, t;
    return (t = (e = this._carouselRef) == null ? void 0 : e.current) == null ? void 0 : t._elState;
  }
  get _configurator() {
    var e, t;
    return (t = (e = this._carouselRef) == null ? void 0 : e.current) == null ? void 0 : t._configurator;
  }
  get _controller() {
    var e, t;
    return (t = (e = this._carouselRef) == null ? void 0 : e.current) == null ? void 0 : t._controller;
  }
}
const zr = ({
  size: r = 0
}) => /* @__PURE__ */ v.jsx(
  "div",
  {
    "data-testid": "bear-carousel-windowSize",
    className: x.testWindowSize,
    children: r
  }
);
function ft(r) {
  var e, t, i = "";
  if (typeof r == "string" || typeof r == "number")
    i += r;
  else if (typeof r == "object")
    if (Array.isArray(r)) {
      var o = r.length;
      for (e = 0; e < o; e++)
        r[e] && (t = ft(r[e])) && (i && (i += " "), i += t);
    } else
      for (t in r)
        r[t] && (i && (i += " "), i += t);
  return i;
}
function xe() {
  for (var r, e, t = 0, i = "", o = arguments.length; t < o; t++)
    (r = arguments[t]) && (e = ft(r)) && (i && (i += " "), i += e);
  return i;
}
const Nr = ye(({
  isActive: r = !1,
  onSlideToPage: e,
  page: t,
  pageContent: i
}, o) => {
  const a = !!i, c = Pe(() => {
    e(t);
  }, [t]);
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      className: xe({
        [x.paginationButton]: !a,
        [x.paginationContent]: a
      }),
      ref: o,
      role: "button",
      onClick: c,
      "data-testid": "bear-carousel-page-button",
      "data-active": W(r),
      "data-page": t,
      children: i
    }
  );
}), dt = Ht({
  isLazy: !1,
  renderLazyPreloader: () => /* @__PURE__ */ v.jsx("div", { children: "loading..." })
}), ht = () => Jt(dt), Lr = (r) => {
  const { children: e, ...t } = r;
  return /* @__PURE__ */ v.jsx(dt.Provider, { value: t, children: e });
}, _t = ({
  className: r,
  testId: e,
  onClick: t
}) => /* @__PURE__ */ v.jsx(
  "button",
  {
    "data-testid": e,
    type: "button",
    className: r,
    onClick: t,
    children: /* @__PURE__ */ v.jsx("div", { className: x.navIcon })
  }
), Wr = ({
  onClick: r
}) => /* @__PURE__ */ v.jsx(_t, { onClick: r, className: [x.navButton, x.navNextButton].join(" "), testId: "bear-carousel-navNextButton" }), Br = ({
  onClick: r
}) => /* @__PURE__ */ v.jsx(_t, { onClick: r, className: [x.navButton, x.navPrevButton].join(" "), testId: "bear-carousel-navPrevButton" }), Vr = ye(({
  style: r,
  className: e,
  setting: t,
  isDebug: i = !1,
  extendStyle: o,
  isEnableGpuRender: a = !0,
  children: c
}, d) => /* @__PURE__ */ v.jsx(
  "div",
  {
    ref: d,
    "data-testid": "bear-carousel",
    style: {
      ...r,
      ...o
    },
    className: [e, x.root].join(" ").trim(),
    "data-gpu-render": W(a),
    "data-per-view-auto": W((t == null ? void 0 : t.slidesPerView) === "auto"),
    "data-mouse-move": W((t == null ? void 0 : t.isEnableMouseMove) ?? !1),
    "data-debug": W(i),
    children: c
  }
));
function Fr(r, e, t) {
  var i;
  if (r.setting.isCenteredSlides) {
    let o = 0;
    const a = (t.slideItemEls && ((i = t.slideItemEls[0]) == null ? void 0 : i.offsetWidth)) ?? 0;
    return t.containerEl && r.setting.slidesPerView === "auto" && (o = (t.containerEl.offsetWidth - a) / 2), o + a * (r.setting.slidesPerViewActual - 1) / 2;
  }
  return 0;
}
function $r(r, e, t) {
  const i = r - e;
  return ir(-i / t);
}
function Yr(r, e) {
  return -r + e;
}
class Gr {
  constructor(e) {
    s(this, "_elementor");
    s(this, "_configurator");
    s(this, "_stater");
    s(this, "_isAnimation", !1);
    s(this, "onSlideAnimation", () => {
      var e, t;
      (e = this._elementor.containerEl) == null || e.addEventListener("transitionstart", this.animationStart, !1), (t = this._elementor.containerEl) == null || t.addEventListener("transitionend", this.animationEnd, !1);
    });
    s(this, "offSlideAnimation", () => {
      var e, t;
      (e = this._elementor.containerEl) == null || e.removeEventListener("transitionstart", this.animationStart, !1), (t = this._elementor.containerEl) == null || t.removeEventListener("transitionend", this.animationEnd, !1);
    });
    /**
     * 取得初始距離
     */
    s(this, "_getStartPosition", () => Fr(this._configurator, this._stater, this._elementor));
    /**
     * Move Percentage
     * @param movePx
     */
    s(this, "getMovePercentage", (e) => {
      const t = (this._elementor.slideItemEls && this._elementor.slideItemEls[this._stater.virtual.activeIndex].offsetWidth) ?? 0, i = this._getStartPosition();
      return $r(e, i, t);
    });
    /**
     * Percentage Move Percentage
     * @param percentage
     */
    s(this, "getPercentageToMovePx", (e) => {
      const t = (this._elementor.slideItemEls && this._elementor.slideItemEls[this._stater.virtual.activeIndex].offsetWidth) ?? 0, i = this._getStartPosition();
      return -(t * e) + i;
    });
    /**
     * Get the target item distance width(px)
     * @param slideIndex
     */
    s(this, "getMoveDistance", (e) => {
      if (this._elementor.slideItemEls && this._elementor.slideItemEls[e]) {
        const t = this._elementor.slideItemEls[e];
        return Yr(t.offsetLeft, this._getStartPosition());
      }
      return 0;
    });
    /**
     * 設定是否移動中
     * 加上狀態讓其他元素不會影響滑動
     * @param isEnable
     */
    s(this, "setTouching", (e) => {
      e ? this._elementor.rootEl && (this._elementor.rootEl.dataset.touching = "") : this._elementor.rootEl && this._elementor.rootEl.removeAttribute("data-touching");
    });
    /**
     * 移動效果
     * @param el
     * @param percentageInfo
     * @param isUseAnimation
     */
    s(this, "_effectFn", (e, t, i = !1) => {
      var o;
      if ((o = this._configurator.setting.moveEffect) != null && o.moveFn) {
        const a = this._configurator.setting.moveEffect.moveFn(t);
        a && (H(a).forEach((c) => {
          e.style[c] = a[c];
        }), i ? e.style.transition = Object.keys(a).map((c) => {
          var d;
          return `${((d = this._configurator.setting.moveEffect) == null ? void 0 : d.moveTime) ?? ".3s"} ${c}`;
        }).join(", ") : e.style.transition = "none");
      }
    });
    s(this, "syncActiveState", () => {
      var c, d, f, g, h, p, m, y, A;
      const e = (c = this._elementor.slideItemEls) == null ? void 0 : c.filter((I) => I), t = this._stater.getInRangeIndex((d = this._stater.virtual) == null ? void 0 : d.activeIndex);
      e == null || e.forEach((I, k) => {
        Number(I == null ? void 0 : I.dataset.virtual) === t ? I.setAttribute("data-active", "") : typeof (I == null ? void 0 : I.dataset.active) < "u" && I.removeAttribute("data-active");
      });
      const i = this._stater.page.activePage;
      this._stater.isVisiblePagination && this._stater.page.activePage > 0 && ((f = this._elementor.pageEls) == null || f.forEach((I, k) => {
        i === k + 1 ? I.setAttribute("data-active", "") : typeof (I == null ? void 0 : I.dataset.active) < "u" && I.removeAttribute("data-active");
      }));
      const o = this._stater.page.total === 1, a = this._stater.virtual.total < this._configurator.setting.slidesPerView;
      typeof ((g = this._elementor.rootEl) == null ? void 0 : g.dataset.firstPage) < "u" && ((h = this._elementor.rootEl) == null || h.removeAttribute("data-first-page")), typeof ((p = this._elementor.rootEl) == null ? void 0 : p.dataset.lastPage) < "u" && ((m = this._elementor.rootEl) == null || m.removeAttribute("data-last-page")), this._stater.isVisibleNavButton && !this._configurator.setting.isEnableLoop && ((i <= 1 || o || a) && ((y = this._elementor.rootEl) == null || y.setAttribute("data-first-page", "")), (i >= this._stater.page.total || o || a) && ((A = this._elementor.rootEl) == null || A.setAttribute("data-last-page", "")));
    });
    s(this, "animationStart", () => {
      this._isAnimation = !0, this._elementor.containerEl && (this._elementor.containerEl.dataset.animation = "");
    });
    s(this, "animationEnd", () => {
      this._isAnimation = !1, this._elementor.containerEl && this._elementor.containerEl.removeAttribute("data-animation");
    });
    this._elementor = e.elementor, this._configurator = e.configurator, this._stater = e.stater;
  }
  get isUseAnimation() {
    var e;
    return ((e = this._elementor.containerEl) == null ? void 0 : e.style.transitionDuration) !== "0ms";
  }
  get isAnimation() {
    return this._isAnimation;
  }
  transform(e, t = !1) {
    return this._elementor.containerEl && (this._elementor.containerEl.style.transform = `translate(${e}px, 0px)`, this._elementor.containerEl.style.transitionDuration = t ? `${this._configurator.setting.moveTime}ms` : "0ms"), this;
  }
  /**
   * 移動效果
   * @param percentage
   * @param isUseAnimation
   */
  moveEffect(e, t = !1) {
    const { moveEffect: i, slidesPerView: o, isCenteredSlides: a } = this._configurator.setting;
    if (typeof o == "number" && (i != null && i.moveFn)) {
      let c = 0;
      if (this._elementor.slideItemEls)
        for (const d of this._elementor.slideItemEls) {
          if (d) {
            const f = a ? Math.floor(o / 2) + 1 : o, g = e - c, h = g >= 0 ? (f - g) / f : (f + g) / f;
            this._effectFn(d, {
              calcPercentage: h,
              percentage: g,
              index: c
            }, t);
          }
          c += 1;
        }
    }
    return this;
  }
}
class Ur extends qt.Component {
  constructor(t) {
    super(t);
    s(this, "_isEnableGpuRender", lt());
    s(this, "state", { windowSize: 0, isClientReady: !1 });
    s(this, "_elementor");
    s(this, "_stater");
    s(this, "_configurator");
    s(this, "_windowSizer");
    s(this, "_elState");
    s(this, "_controller");
    s(this, "_autoPlayer");
    s(this, "_dragger");
    s(this, "_syncCarousels");
    s(this, "_init", () => {
      this.setState({ isClientReady: !0 }, () => {
        var t;
        (t = this._controller) == null || t.slideToPage(1, !1);
      });
    });
    /**
     * set Controller method
     */
    s(this, "_setController", () => {
      this.props.setController && this._controller && this.props.setController(this._controller);
    });
    /**
     *
     * set OnAutoPlay emit
     */
    s(this, "_onAutoPlay", () => {
      var t;
      (t = this._controller) == null || t.slideToNextPage();
    });
    /**
     *
     * set OnSlideBefore emit
     */
    s(this, "_onSlideBefore", () => {
      var t;
      (t = this._autoPlayer) == null || t.pause();
    });
    /**
     *
     * set OnSlideAfter emit
     * @param index
     * @param isUseAnimation
     */
    s(this, "_onSlideAfter", (t, i) => {
      var o, a;
      (o = this._syncCarousels) == null || o.forEach((c) => c.slideToSourceIndex(t, i)), (a = this._autoPlayer) == null || a.play();
    });
    /**
     * set OnDragStart emit
     */
    s(this, "_onDragStart", () => {
      var t, i;
      (t = this._controller) == null || t.slideResetToMatchIndex(), (i = this._autoPlayer) == null || i.pause();
    });
    /**
     * set OnDragEnd emit
     * @param activeSourceIndex
     */
    s(this, "_onDragEnd", (t) => {
      var i, o;
      (i = this._controller) == null || i.slideToVirtualIndex(t), (o = this._syncCarousels) == null || o.forEach((a) => a == null ? void 0 : a.syncControlDone(t));
    });
    /**
     * set OnDragMove emit
     * @param percentage
     */
    s(this, "_onDragMove", (t) => {
      var i;
      (i = this._syncCarousels) == null || i.forEach((o) => o == null ? void 0 : o.syncControlMove(t));
    });
    /**
    * set OnChange emit
    */
    s(this, "_onChange", () => {
      if (this.props.onSlideChange && this._stater) {
        const { source: t, virtual: i, page: o } = this._stater;
        this.props.onSlideChange({ source: t, virtual: i, page: o });
      }
    });
    s(this, "_onResize", (t) => {
      var i, o;
      if (t.windowSize !== this.state.windowSize)
        this.setState({ windowSize: t.windowSize });
      else {
        const a = (i = this._stater) == null ? void 0 : i.source.activeIndex;
        (o = this._controller) == null || o.slideToSourceIndex(a, { isUseAnimation: !1 });
      }
    });
    /**
    * Render left and right navigation blocks
    */
    s(this, "_renderNavButton", () => {
      var i, o, a;
      const { renderNavButton: t } = this.props;
      return typeof t < "u" && this._controller ? /* @__PURE__ */ v.jsx(v.Fragment, { children: t(this._controller.slideToPrevPage, this._controller.slideToNextPage) }) : /* @__PURE__ */ v.jsxs(
        "div",
        {
          ref: (i = this._elementor) == null ? void 0 : i._navGroupRef,
          className: x.navGroup,
          children: [
            /* @__PURE__ */ v.jsx(Br, { onClick: (o = this._controller) == null ? void 0 : o.slideToPrevPage }),
            /* @__PURE__ */ v.jsx(Wr, { onClick: (a = this._controller) == null ? void 0 : a.slideToNextPage })
          ]
        }
      );
    });
    /**
     * render slide item
     */
    s(this, "_renderSlideItems", () => {
      var a, c;
      const { isDebug: t } = this.props, i = (a = this._stater) == null ? void 0 : a.virtual, o = (c = this._stater) == null ? void 0 : c.formatElement;
      return o == null ? void 0 : o.map((d, f) => {
        const g = d.virtualIndex === (i == null ? void 0 : i.activeIndex);
        return /* @__PURE__ */ v.jsx(
          Pr,
          {
            ref: (h) => {
              var p;
              return h && ((p = this._elementor) == null ? void 0 : p.setSlideItemRefs(h, f));
            },
            element: d.element,
            virtualIndex: d.virtualIndex,
            matchIndex: d.matchIndex,
            inPage: d.inPage,
            sourceIndex: d.sourceIndex ?? 0,
            isActive: g,
            isClone: d.isClone,
            isDebug: t,
            index: f
          },
          `bear-carousel_slide-item_${d.key}`
        );
      });
    });
    /**
     * Page number navigation buttons
     */
    s(this, "_renderPagination", () => {
      var f, g, h, p, m, y;
      const { renderPagination: t } = this.props, i = (f = this._stater) == null ? void 0 : f.page, o = (h = (g = this._configurator) == null ? void 0 : g.setting) == null ? void 0 : h.isEnablePageContent;
      let a;
      typeof t < "u" && (a = t(((m = (p = this._stater) == null ? void 0 : p.page) == null ? void 0 : m.total) ?? 0));
      const d = Array.from({ length: (i == null ? void 0 : i.total) ?? 0 }).map((A, I) => /* @__PURE__ */ v.jsx(
        Nr,
        {
          ref: (k) => {
            var D;
            return k && ((D = this._elementor) == null ? void 0 : D.setPageRefs(k, I));
          },
          onSlideToPage: (k) => {
            var D;
            return (D = this._controller) == null ? void 0 : D.slideToPage(k);
          },
          page: I + 1,
          isActive: (i == null ? void 0 : i.activePage) === I + 1,
          pageContent: o && typeof a < "u" && a[I]
        },
        `page_${I}`
      ));
      return /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: (y = this._elementor) == null ? void 0 : y._pageGroupRef,
          "data-page-content": W(o ?? !1),
          className: x.paginationGroup,
          children: d
        }
      );
    });
    const { data: i, breakpoints: o, onMount: a, syncCarouselRefs: c } = t, d = me(this.props);
    this._configurator = new gr({
      breakpoints: o,
      defaultBreakpoint: d,
      win: globalThis.window
    }), this._stater = new Er(this._configurator, i), this._elementor = new xr({
      configurator: this._configurator,
      stater: this._stater
    });
  }
  componentDidMount() {
    this.props.isDebug && M.componentDidMount && C.printInText("[componentDidMount]");
    const { breakpoints: t, onMount: i, syncCarouselRefs: o } = this.props;
    this._configurator && (this._windowSizer = new mr({
      breakpoints: t,
      win: globalThis.window,
      configurator: this._configurator
    }), this._stater.onChange(this._onChange), this._elState = new Gr({
      configurator: this._configurator,
      elementor: this._elementor,
      stater: this._stater
    }), this._controller = new Tr({
      configurator: this._configurator,
      stater: this._stater,
      elState: this._elState
    }), this._dragger = new kr({
      configurator: this._configurator,
      elementor: this._elementor,
      elState: this._elState,
      stater: this._stater
    }), this._autoPlayer = new Rr({
      configurator: this._configurator
    }), this._windowSizer.onResize(this._onResize), this._autoPlayer.onTimeout(this._onAutoPlay), this._dragger.onDragStart(this._onDragStart), this._dragger.onDragMove(this._onDragMove), this._dragger.onDragEnd(this._onDragEnd), this._controller.onSlideBefore(this._onSlideBefore), this._controller.onSlideAfter(this._onSlideAfter), o && (this._syncCarousels = o.map((a) => new Or(a))), this._setController(), this._elState.onSlideAnimation(), this._init(), i && i());
  }
  componentWillUnmount() {
    var t, i, o;
    this.props.isDebug && M.componentWillUnmount && C.printInText("[componentWillUnmount]"), (t = this._windowSizer) == null || t.offResize(this._onResize), (i = this._autoPlayer) == null || i.offTimeout(this._onAutoPlay), this._dragger && (this._dragger.offDragStart(this._onDragStart), this._dragger.offDragMove(this._onDragMove), this._dragger.offDragEnd(this._onDragEnd)), this._controller && (this._controller.offSlideBefore(this._onSlideBefore), this._controller.offSlideAfter(this._onSlideAfter)), this._elState && this._elState.offSlideAnimation(), (o = this._stater) == null || o.offChange(this._onChange);
  }
  /***
  * Optimized rendering
  * @param nextProps
  * @param nextState
  */
  shouldComponentUpdate(t, i) {
    var m, y, A, I, k, D, R;
    (m = this._configurator) != null && m.setting.isDebug && M.shouldComponentUpdate && C.printInText("[shouldComponentUpdate]");
    const { windowSize: o, isClientReady: a } = this.state, { windowSize: c, isClientReady: d } = i, { data: f, ...g } = this.props, { data: h, ...p } = t;
    if (d !== a)
      return !0;
    if ((f == null ? void 0 : f.length) !== (h == null ? void 0 : h.length))
      return (y = this._configurator) == null || y.init({
        defaultBreakpoint: me(t),
        breakpoints: t.breakpoints
      }), (A = this._stater) == null || A.reset(t.data), setTimeout(() => {
        var V;
        (V = this._controller) == null || V.slideToPage(1, !1);
      }, 0), !0;
    if (o !== c || or(g, p, ["moveEffect"])) {
      const V = (I = this._stater) == null ? void 0 : I.source.activeIndex;
      return (k = this._configurator) == null || k.init({
        defaultBreakpoint: me(t),
        breakpoints: t.breakpoints
      }), (D = this._stater) == null || D.reset(t.data), setTimeout(() => {
        var ee;
        (ee = this._controller) == null || ee.slideToSourceIndex(V ?? 0, { isUseAnimation: !1 });
      }, 0), !0;
    }
    return t.isSlideItemMemo && f !== h || sr(this.props.data, t.data) ? ((R = this._stater) == null || R.updateData(t.data), !0) : !1;
  }
  render() {
    var d, f, g, h, p, m;
    const { style: t, className: i, isDebug: o, isLazy: a, renderLazyPreloader: c } = this.props;
    return /* @__PURE__ */ v.jsxs(
      Vr,
      {
        ref: (d = this._elementor) == null ? void 0 : d._rootRef,
        style: t,
        className: i,
        setting: (f = this._configurator) == null ? void 0 : f.setting,
        isDebug: o,
        extendStyle: (g = this._configurator) == null ? void 0 : g.style,
        isEnableGpuRender: globalThis.window && this._isEnableGpuRender,
        children: [
          this.state.isClientReady && ((h = this._stater) == null ? void 0 : h.isVisibleNavButton) && this._renderNavButton(),
          /* @__PURE__ */ v.jsx("div", { className: x.content, children: /* @__PURE__ */ v.jsx("div", { ref: (p = this._elementor) == null ? void 0 : p._containerRef, className: x.container, "data-testid": "bear-carousel-container", children: /* @__PURE__ */ v.jsx(
            Lr,
            {
              isLazy: a,
              renderLazyPreloader: c || (() => /* @__PURE__ */ v.jsx("div", { children: "loading..." })),
              children: this.state.isClientReady && this._renderSlideItems()
            }
          ) }) }),
          this.state.isClientReady && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            ((m = this._stater) == null ? void 0 : m.isVisiblePagination) && this._renderPagination(),
            o && this._windowSizer && /* @__PURE__ */ v.jsx(zr, { size: this._windowSizer.size })
          ] })
        ]
      }
    );
  }
}
s(Ur, "defaultProps", {
  data: void 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  // 不可為小數
  breakpoints: {},
  isCenteredSlides: !1,
  isEnableLoop: !1,
  isEnablePageContent: !1,
  isEnablePagination: !1,
  isEnableNavButton: !1,
  isEnableMouseMove: !0,
  isEnableAutoPlay: !1,
  movePercentage: 0.33,
  isDebug: !1,
  spaceBetween: 0,
  moveTime: 500,
  autoPlayTime: 5e3,
  initStartPlayTime: 1500,
  isSlideItemMemo: !1
});
const Xr = ({ isLazy: r, imageUrl: e }) => {
  const t = ae(null), i = ae(), [o, a] = ve(
    0
    /* ready */
  );
  ot(() => {
    r && t.current && e && (i.current = new globalThis.window.IntersectionObserver(c), i.current.observe(t.current));
  }, [e, r]);
  const c = Pe((d, f) => {
    for (let g of d)
      if (g.isIntersecting) {
        const h = g.target;
        o === 0 && (a(
          1
          /* loading */
        ), h.src = e, h.onload = () => a(
          2
          /* done */
        ), h.onerror = () => a(
          3
          /* fail */
        )), f.unobserve(h);
      }
  }, [o]);
  return { imageRef: t, status: o };
};
var J = /* @__PURE__ */ ((r) => (r[r.ready = 0] = "ready", r[r.loading = 1] = "loading", r[r.done = 2] = "done", r[r.fail = 3] = "fail", r))(J || {});
const qr = ({ isLazy: r, imageUrl: e }) => {
  const t = ae(null), [i, o] = ve(
    0
    /* ready */
  ), [a, c] = ve(void 0), d = ae();
  ot(() => {
    r && t.current && e && (d.current = new window.IntersectionObserver(f), d.current.observe(t.current));
  }, [e, r]);
  const f = Pe((g, h) => {
    for (let p of g)
      if (p.isIntersecting) {
        const m = p.target;
        if (i === 0) {
          const y = new Image();
          o(
            1
            /* loading */
          ), m.dataset.lazySrc && (y.src = m.dataset.lazySrc, y.onload = () => {
            o(
              2
              /* done */
            ), c(y.src);
          }, y.onerror = () => o(
            3
            /* fail */
          ));
        }
        h.unobserve(m);
      }
  }, [i]);
  return { imageRef: t, status: i, doneImageUrl: a };
}, en = ({
  className: r,
  style: e,
  imageUrl: t,
  imageAlt: i,
  imageSize: o,
  onClick: a
}) => {
  const c = ht(), { imageRef: d, status: f } = Xr({ isLazy: c.isLazy ?? !1, imageUrl: t });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      "img",
      {
        ref: d,
        style: e,
        className: xe(r, x.slideItemImage, {
          [x.slideItemImageNone]: o === "none",
          [x.slideItemImageCover]: o === "cover",
          [x.slideItemImageContain]: o === "contain",
          [x.slideItemImageScaleDown]: o === "scaleDown"
        }),
        src: !c.isLazy && t ? t : void 0,
        alt: i,
        draggable: "false",
        "data-lazy-src": c.isLazy && f !== J.done ? t : void 0,
        onClick: a
      }
    ),
    c.isLazy && f === J.loading && /* @__PURE__ */ v.jsx("div", { className: x.slideItemImagePreLoad, children: c.renderLazyPreloader() })
  ] });
}, tn = ({
  className: r,
  style: e,
  bgUrl: t,
  bgSize: i = "cover",
  children: o,
  onClick: a
}) => {
  const c = ht(), { imageRef: d, status: f, doneImageUrl: g } = qr({ isLazy: c.isLazy, imageUrl: t }), h = c.isLazy ? g : t;
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      ref: d,
      className: xe(r, x.slideItemCard, {
        [x.slideItemCard100]: i === "100%",
        [x.slideItemCardCover]: i === "cover",
        [x.slideItemCardContain]: i === "contain"
      }),
      onClick: a,
      "data-lazy-src": c.isLazy && f !== J.done ? t : void 0,
      style: {
        ...e,
        backgroundImage: h ? `url(${h})` : void 0
      },
      children: c.isLazy && f === J.loading ? /* @__PURE__ */ v.jsx("div", { className: x.slideItemImagePreLoad, children: c.renderLazyPreloader() }) : o
    }
  );
}, Hr = (r = 50) => (e) => ({
  transform: `translate(0px, ${-r * (e.calcPercentage - 1)}px)`
}), Jr = (r = 1) => (e) => ({
  opacity: e.calcPercentage * r
}), Kr = (r = 1) => (e) => ({
  transform: `rotate(${360 * e.percentage}deg)`
}), rn = {
  transformY: Hr,
  opacity: Jr,
  rotate: Kr
};
export {
  tn as BearSlideCard,
  en as BearSlideImage,
  Tr as Controller,
  z as EDevice,
  Ur as default,
  x as elClassName,
  rn as moveEffectFn
};
